import './fix.cross-origin'
import {MessageBox} from "element-ui/packages/message-box/src/main";

/**
 * @method：typeOf
 * @createdBy:HuangJian
 * @date:2018/02/28
 * @params：
 * @description：获取变量类型
 */
export function typeOf(obj) {
    const toString = Object.prototype.toString;
    const str = toString.call(obj);
    const regExp = /\[object (\w*)\]/;
    if(regExp.test(str)){
        return (RegExp.$1 || '').toLowerCase();
    }
}

/**
 * @method：replaceAll
 * @createdBy：HuangJian
 * @date：2018/11/1
 * @description：字符串替换函数
 *
 */

String.prototype.replaceAll = function (reallyDo, replaceWith, ignoreCase) {
    if (!RegExp.prototype.isPrototypeOf(reallyDo)) {
        return this.replace(new RegExp(reallyDo, ignoreCase ? 'gi' : 'g'), replaceWith);
    } else {
        return this.replace(reallyDo, replaceWith);
    }
};


/**
 * @method：format
 * @createdBy：HuangJian
 * @date：2018/11/1
 * @params：
 * @description：
 对Date的扩展，将 Date 转化为指定格式的String
 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 例子：
 (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */

Date.prototype.format = function (fmt) {
	if (!!fmt) {
		fmt = fmt.replace(/(H)/g, 'h')
	}
    var o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'h+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds() // 毫秒
    };
    if ((/(y+)/).test(fmt)) fmt = fmt.replace(RegExp.$1, String(this.getFullYear()).substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
    return fmt;
};
/**
 * @method：dateFormat
 * @createdBy:HuangJian
 * @date:2019/2/18
 * @params：
 * @description：针对字符串的日期格式化原型函数
 */
String.prototype.dateFormat = function (fmt) {
    var str = String(this).replace(/-/g, '/').
        replace(/\.[0-9]+$/, '');
    var date = null;
    try {
        date = new Date(str);
    }catch (e) {}
    if(date===null){
        return this;
    }
    return date.format(fmt);
};
(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('linkTools', [], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS, node
        exports = factory(global);
        // factory(exports, require('linkTools'));
    } else {
        // Browser globals
        factory(global);
    }
}(typeof window === 'undefined' ? this : window, function (global) {

    // 使用顶级对象
    if(global && global.linkTools){
        return global.linkTools;
    }


    /**
     * 计算获取菜单标记, 返回各标记属性组成的新对象
     * @param menu 二级菜单
     * @param securityMenu 安全性菜单
     * @returns 安全性配置对象
     * @author yaorunfa
     */
    function getMenuFlag(menu, securityMenu) {
        var obj = {};
        if (!securityMenu) {
            if (menu.readonlyFlag == 'Y') {
                obj.readonlyFlag = 'Y';
                obj.addFlag = 'N';// 只读，作用于子页面
                obj.editFlag = 'N';
                obj.deleteFlag = 'N';
                obj.importFlag = 'N';
            } else {
                obj.readonlyFlag = 'N';
                obj.addFlag = menu.addFlag;
                obj.editFlag = menu.editFlag;
                obj.deleteFlag = menu.deleteFlag;
                obj.importFlag = menu.importFlag;
            }
            obj.oauth = '';
            obj.defaultNoQueryFlag = menu.defaultNoQueryFlag;
            obj.exportFlag = menu.exportFlag;
            obj.openNewpageFlag = menu.openNewpageFlag;
        } else if (securityMenu) {
            // 根据菜单配置，设置页面可见性
            if (menu.readonlyFlag == 'Y') { // 只读标记为Y,则增删改标记都设为N
                obj.readonlyFlag = 'Y';
                obj.addFlag = 'N';
                obj.editFlag = 'N';
                obj.deleteFlag = 'N';
                obj.importFlag = 'N';
            } else {
                if (securityMenu.readonlyFlag == 'Y') { // 安全性菜单只读标记为Y
                    obj.readonlyFlag = 'Y';
                    obj.addFlag = 'N';
                    obj.editFlag = 'N';
                    obj.deleteFlag = 'N';
                    obj.importFlag = 'N';
                } else {
                    obj.readonlyFlag = 'N';
                    obj.addFlag = securityMenu.addFlag;
                    obj.editFlag = securityMenu.editFlag;
                    obj.deleteFlag = securityMenu.deleteFlag;
                    obj.importFlag = securityMenu.importFlag;
                }
            }
            obj.oauth = securityMenu.oauthType;
            // obj.defaultNoQueryFlag = securityMenu.defaultNoQueryFlag;
            obj.exportFlag = securityMenu.exportFlag;
            // obj.openNewpageFlag = securityMenu.openNewpageFlag;
        }
        obj.defaultNoQueryFlag = menu.defaultNoQueryFlag;
        obj.openNewpageFlag = menu.openNewpageFlag;
        return obj;
    }

    /**
     * 把有树形关系的列表结构的数据转换为适用于树形结构的数据
     * @param rows 对象数组
     * @param parentIdName 对象上标明父对象的字段的名称
     * @param subIdName 对象上的唯一性标识字段
     * @param subListName 用于存放子对象列表的字段的名称
     * @returns {Array}
     */
    function convertToTree(rows, parentIdName, subIdName, subListName){
		if(!parentIdName){
			parentIdName = 'parentId';
		}
		if(!subIdName){
			subIdName = 'id';
		}
		if(!subListName){
			subListName = 'children';
		}
		function notBlank(str) {
			return str !== undefined && str !== null && str !== ''
		}
		function exists(rows, parentId){
			if(!notBlank(parentId)) {
				return false
			}
			for(var i=0; i<rows.length; i++){
				if (rows[i][subIdName] === parentId) return true;
			}
			return false;
		}

		var nodes = [];
		for(var i=0; i<rows.length; i++){ // 获取顶层父节点，先报根节点加入数组中
			var row = rows[i];
			if (!exists(rows, row[parentIdName])){
				nodes.push(row);
			}
		}

		var toDo = [];
		for(let i=0; i<nodes.length; i++){
			toDo.push(nodes[i]);
		}
		while(toDo.length){
			var node = toDo.shift();// 获取数组中第一个对象，并查找此对象的子

			for(let i=0; i<rows.length; i++){
				const row = rows[i];
				if (row[parentIdName] === node[subIdName] && notBlank(row[parentIdName])){
					if (node[subListName]){
						node[subListName].push(row);
					} else {
						node[subListName] = [row];
					}
					toDo.push(row);
					rows.splice(i, 1);
					i--;
				}
			}
		}
		return nodes;
	}

    /**
     * @description 根据参数名称获取路径上参数
     * @param name 参数名称
     * @param searchStr 路径，不填则默认为当前窗口路径
     * @return
     * @author yrf
     * @date 2018/10/29
     */
    function getQueryString(name, searchStr) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        var r = null;
        if(searchStr){
            r = searchStr.substr(1).match(reg);
        }else{
            r = window.location.search.substr(1).match(reg);
        }
        if (r != null){
            return decodeURIComponent(r[2]);
        }
        return null;
    }
    /**
     * @method：deepCopy
     * @createdBy：HuangJian
     * @param：
     *  obj：需要拷贝的对象
     * @returns：obj的副本
     * @description：用于对象的深度拷贝
     */
    function deepCopy(obj) {
        if(['array', 'object'].indexOf(typeOf(obj))<0){
            return obj;
        }
        var root = Array.isArray(obj)?[]:{};
        for(const key in obj){
            const prop = obj[key];
            const type = typeOf(prop);
            const ifDeepCopy = ['array', 'object'].indexOf(type)>-1;
            root[key] = ifDeepCopy?deepCopy(prop):prop;
        }
        return root;
    }

    /**
     * @method：copyObjByMap
     * @createdBy：HuangJian
     * @param：
     *  val：需要拷贝的对象
     *  map：对象的属性映射图
     *  mode:是否深拷贝子对象,默认值为true
     * @returns：新对象的引用
     * @description：用于拷贝对象里的特定属性，并映射为新的属性
     *   var map={id:'acctId'},val={id:'WA1111'};
     *   var newVal = copyObjByMap(val,map);
     *   newVal的值为：{acctId:'WA1111'},即id-->acctId
     */
    function copyObjByMap(val, map, mode=true) {
        const newVal={};

        if(typeOf(val)!=='object' || typeOf(map)!=='object'){
            return newVal;
        }

        for(const keyLeft in map){
            const keyRight = map[keyLeft];
            const prop = val[keyLeft];
            const type = typeOf(prop);
            const ifDeepCopy = mode && ['array', 'object'].indexOf(type)>-1;
            newVal[keyRight] = ifDeepCopy?deepCopy(prop):prop;
        }

        return newVal;
    }

    /**
     * @method：coverPropsByTpl
     * @createdBy：HuangJian
     * @param：
     *  obj：需要覆盖的对象
     *  tpl：默认值模板
     *  mode:是否深拷贝子对象,默认值为true
     *  @returns：obj对象
     * @description：将一个对象的所有属性覆盖到另一个对象
     */
    function coverPropsByTpl(obj={}, tpl, mode=true) {
        if(typeOf(obj)!=='object' || typeOf(tpl)!=='object'){
            return obj;
        }
        for(var key in tpl){
            const prop = tpl[key];
            const type = typeOf(prop);
            const ifDeepCopy = mode && ['array', 'object'].indexOf(type)>-1;
            if(ifDeepCopy){
                if(obj.hasOwnProperty(key) && typeOf(obj[key])===type){
                    coverPropsByTpl(obj[key], prop, mode);
                }else{
                    obj[key] = deepCopy(prop);
                }
            }else {
                obj[key] = prop;
            }
        }
        return obj;
    }

    /**
     * @method：copyObjProps
     * @createdBy：HuangJian
     * @param：
     *  val：要拷贝的对象
     *  props:需要的拷贝的属性，类型为数组
     *  mode:是否深拷贝子对象,默认值为true
     * @returns：新对象的应用
     * @description：用于拷贝对象特定属性
     *  var props=['id','accntName'],val={id:'WA1111',accntName:'汉得信息',acctLevel:'VIP'};
     *  var newVal=copyObjProps(val,props);
     *  newVal的值为:{id:'WA1111',accntName:'汉得信息'}
     */
    function copyObjProps(val, props, mode=true) {
        if(typeOf(val)!=='object' || ['array', 'string'].indexOf(typeOf(props))<0){
            return {};
        }
        const newVal = {};
        if(typeOf(props)==='string') props=[props];
        for(const i in props){
            const key = props[i];
            const prop = val[key];
            const type = typeOf(prop);
            const ifDeepCopy = mode && ['array', 'object'].indexOf(type)>-1;
            newVal[key] = ifDeepCopy?deepCopy(prop):prop;
        }
        return newVal;
    }

    /**
     * @method：delObjProps
     * @createdBy：HuangJian
     * @param：
     obj:操作的对象
     props:需要删除的属性
     * @description：删除对象的特定属性
     */
    function delObjProps(obj, props) {
        if(typeOf(obj)!=='object' || ['array', 'string'].indexOf(typeOf(props))<0) {
            return;
        }
        if(typeOf(props)==='string'){
            props = [props];
        }
        for (const i in props){
            const key = props[i];
            if(obj.hasOwnProperty(key)){
                delete obj[key];
            }
        }
        return obj;
    }


    function getDateStr(date, format) {
        if(!date) return '';
        if(!(date instanceof Date)) return date;
        if(!format){
            format = 'yyyy-MM-dd';
        }
        return date.format(format);
    }

    /**
     * 获得指定时间月第一天，默认为当前时间
     * @author NingLanhao
     * @date 2018-12-17 17:20
     */
    function getFirstDayOfMonth(date) {
        if (!date) {
            date = new Date();
        }
        if (!(date instanceof Date)) {
            return date;
        }
        const y = date.getFullYear();
        const m = date.getMonth();
        return new Date(y, m, 1);
    }
    /**
     * 获得指定日期的加减指定天数后的时间
     * @author NingLanhao
     * @date 2018-12-27 16:56
     * @param date 日期类型
     * @param days 调整天数，负数则往前调整，
     * @returns {Date}
     */
    function addDate(date, days) {
        if (!date) {
            date = new Date();
        }
        date.setDate(date.getDate() + days);
        var m = date.getMonth() + 1;
        const addDate = new Date(date.getFullYear(), m, date.getDate());
        return addDate;
    }

    /**
     *  指定列导出
     *
     *  @author NingLanhao
     * @date 2019-03-05 15:46
     * @param component VUE 组件对象，一般用this
     * @param exportFields 导出列<p>对象格式：<br/>{checked: true, field: 'brand', name: '品牌', lov: 'PROD_BRAND'}<p/>
     * @param gridOption AutoOption表格对象
     */
    async function exportColumn(component, exportFields, gridOption){
        const ret = await component.$lv.$export.show(exportFields);

        const fields = ret.fields;
        const exportsRaw = [];
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            var exportsCol = {
                title: field.name,
                field: field.field,
                order: i
            };
            if (field.lov) {
                var lovArray = linkLov.getLovArray(field.lov);
                var lovMap = {};
                for (let j = 0; j < lovArray.length; j++) {
                    lovMap[lovArray[j].val] = lovArray[j].name;
                }
                exportsCol.lov = field.lov;
                exportsCol.lovMap = lovMap;
            }
            exportsRaw.push(exportsCol);
        }
        var option = {
            exportsRaw: exportsRaw,
            exportCurrentPage: ret.range === 'all' ? 'N' : 'Y',
            exportFileName: ret.fileName,
            exportFileType: ret.fileType
        };
        await gridOption._requestExportData(option);
    }

    function NumbertoLen2String(n) {
        if (n.toString().length == 1) {
            return '0' + n.toString();
        } else {
            return n;
        }
    }

    /**
     * 指定格式，格式化日期
     * 2018-5-30
     * (new Date()).Format("yyyy-MM-dd hh:mm:ss") ==> 2018-05-30 15:42:45
     * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2018-05-30 15:42:45.195
     * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2018-5-30 15:42:26.625
     * **/
    function getDateFormat(fmt) {
        var date = new Date();
        return date.format(fmt);
    }

    function isEmpty(v) {
        if (v === '') {
            return true;
        }
        switch (typeof v) {
            case 'date':
                return true;
            case 'undefined':
                return true;
            case 'string':
                if (v.trim().length === 0)
                    return true;
                break;
            case 'boolean':
                if (!v)
                    return true;
                break;
            case 'number':
                if (v === 0)
                    return true;
                break;
            case 'object':
                if (v === null) {
                    return true;
                } else if (undefined !== v.length && v.length === 0) {
                    return true;
                } else {
                    return false;
                }
            default:
                break;
        }
        return false;
    }

    /**
     * 排除指定值列表
     * @author 程厚霖
     * @param lovOptions 所有的值列表
     * @param excludeLov 排除的值列表
     */
    function excludeLov(lovOptions, excludeLov) {
        var options = deepCopy(lovOptions);
        for (let i = 0; i < options.length; i++) {
            for (let j = 0; j < excludeLov.length; j++) {
                if (i >= 0 && options[i].val == excludeLov[j]) {
                    options.splice(i, 1);
                    i--;
                }
            }
        }
        return options;
    }

    /**
     * 合并多个值列表
     * @example
     * ```
     * var lovs = mergeLov('SALES_ORDER_STATUS','SHOP_PUR_ORDER_STATUS')
     * ```
     * @param lovs 值列表类型
     * @return array 合并后的数组，val和name相同的值除外
     */
    function mergeLov(...lovs) {
        var resultLov = [].concat(linkLov.getLovArray(lovs[0]));
        for (let i = 1, len = lovs.length; i < len; i++) {
            var tempLov = [].concat(linkLov.getLovArray(lovs[i]));
            for (let j = 0; j < tempLov.length; j++) {
                for (let k = 0; k < resultLov.length; k++) {
                    if (resultLov[k].val === tempLov[j].val && resultLov[k].name === tempLov[j].name) {
                        tempLov.splice(j, 1);
                        j--;
                    }
                }
            }
            resultLov = resultLov.concat(tempLov);
        }
        return resultLov;
    }

    /**
     * @method：getDefaultVal
     * @param：
     *  obj：需要加载默认值的对象
     *  tpl：默认值模板
     *  mode:是否深拷贝子对象,默认值为true
     *  @returns：obj对象
     * @description：用于新建时的默认值加载
     */
    function getDefaultVal(obj, tpl, mode) {
        if (!obj || !tpl) return obj;
        if (typeof mode != 'boolean') mode = true;
        for (var key in tpl) {
            var tmp = tpl[key];
            if (mode && typeof tmp === 'object') {
                if (tmp.constructor === Array) {
                    obj[key] = deepCopy(tmp);
                } else {
                    if (!obj[key]) obj[key] = {};
                    getDefaultVal(obj[key], tmp, mode);
                }

            } else obj[key] = tmp;
        }
        return obj;
    }


    /**
     * 指定格式，日期字符串转日期
     * 2018-01-12  ==>  Fri Jan 12 2018 00:00:00 GMT+0800 (中国标准时间)
     * **/
    function convertDateFromString(dateString) {
        if (dateString) {
            var date = new Date(dateString.replace(/-/, '/'));
            return date;
        }
    }

    /**
     *@methods:splitTime
     *@description:切割时间字符串
     **/
    function splitTime(d) {
        if(d != undefined){
            var arr = d.split('');
            if(arr.indexOf(' ') != -1){
                return arr.slice(0, arr.indexOf(' ')).join('');
            }else{
                return d;
            }
        }else{
            return '暂无日期';
        }
    }

    /**
     *@createdBy 常九福
     *@date 2018/12/7
     *@methods:getUrlParam
     *@para: name 自定义字段
     *@description:取页面路径的某个字段所对应的参数
     **/
    function getUrlParam(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
        var r = decodeURI(window.location.search).substr(1).
            match(reg); // 匹配目标参数
        if (r != null) return unescape(r[2]);
        return null; // 返回参数值
    }
    /**
     * @method：printByTemplate
     * @createdBy:HuangJian
     * @date:2018/12/20
     * @params：
     * @description：打印指定的html模板
     */
    function printByTemplate(url, data, title) {
        title = title || '';

        const html = `
    <!DOCTYPE html>
    <html lang="en" style="height: 100%;width: 100%;overflow: hidden">
    <head>
        <meta charset="UTF-8">
        <title>${title}</title>
    </head>
    <body style="height: 100%;margin: 0">
        <iframe src="${url}" frameborder="0" style="width: 100%;height: 100%"></iframe>
    </body>
    </html>
    `;
        try {
            const win = window.open();
            win.CURRENT_ORIGIN_TOP.printData =deepCopy(data);
            win.CURRENT_ORIGIN_TOP.token=linkToken.getLocalToken();
            win.CURRENT_ORIGIN_TOP.appCtx=appCtx;
            win.document.write(html);
        }catch (e) {
            MessageBox.alert('打印窗口被浏览器拦截！', '错误');
        }
    }

    /**
     * @createdBy:WangYue
     * @date:2019/4/28
     * @params：36/10
     * @description：将数据十进制数字转化成三十六进制
     */
     function LinkIdToString(val){
        let num = (val-0).toString(36);
        if(isNaN(val-0)){
            return val;
        }else {
            return num.toUpperCase();
        }
    }
    /**
     * @createdBy:WangYue
     * @date:2019/4/28
     * @params：36/10
     * @description：将三十六进制数字转换成十进制
     */
     function LinkStringToId(val){
        let num = parseInt(val,36);
        console.log(num);
        if(isNaN(num)){
            return val;
        }else {
            return num;
        }
    }

    /**
     * 负责字符串到剪贴板
     * @author 姚润发
     * @date 2019/07/10
     */
    function copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        return true;
    }

    // 指定返回的工具函数对象
    var linkTools = {
        getMenuFlag, // 计算返回当前菜单安全性标志
        convertToTree, // 列表格式数据转换为树形嵌套列表数据
        getQueryString, // 获取当前页面路径参数
        deepCopy, // 深度复制对象
        copyObjByMap, // copy对象指定属性，并映射为新名称，map key为原对象属性名，value为新对象属性名
        coverPropsByTpl, // 将一个对象的所有属性覆盖到另一个对象
        copyObjProps, // 复制对象的特定属性
        delObjProps, // 删除对象的特定属性
        getDateStr, // 将日期转化为特定格式的字符串
        getFirstDayOfMonth, // 获取一个月的第一天
        exportColumn, // 指定列导出
        NumbertoLen2String, // 针对2位数的格式化函数，如9->09
        getDateFormat, // 按特定格式返回当前日期的字符串
        isEmpty, // 判断值是否为空
        convertDateFromString, // 将字串转化为日期类型
        splitTime, // 切割时间字符串
        excludeLov, // 排除指定的值列表
        mergeLov, // 合并指定的值列表
        getDefaultVal, //加载默认值
        getUrlParam, // 获取页面路径的某个字段所对应的参数
        printByTemplate, // 打印指定的html模板
        addDate,// 获得指定日期的加减指定天数后的时间
        LinkIdToString,//将数据十进制数字转化成三十六进制
        LinkStringToId,//将三十六进制数字转换成十进制
        copyToClipboard // 复制字符串到剪贴板
    };
    if(global){
        global.linkTools = linkTools;
    }
    return linkTools;
}));


/**
 * @method：camelcaseToHyphen
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * @description：驼峰转连字符
 */
function camelcaseToHyphen (str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export {camelcaseToHyphen};

const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;

/**
 * @method：camelCase
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * @description：字符串转驼峰
 */
function camelCase(name) {
    return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
        return offset ? letter.toUpperCase() : letter;
    }).replace(MOZ_HACK_REGEXP, 'Moz$1');
}

export {camelCase};

/**
 * @method：firstUpperCase
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * @description：首字符大写
 */
function firstUpperCase(str) {
    return str.toString()[0].toUpperCase() + str.toString().slice(1);
}
export {firstUpperCase};

/**
 * @method：
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * context：组件句柄(默认当前Vue实例)
 * @description：获取组件名称
 */
function getComponentName(context){
    context = context || this;
    var vnode = context.$vnode || {};
    var result = null;
    var tag = String(vnode.tag || '');
    const regExp = /vue-component-\w*-(.*)$/;
    if(regExp.test(tag)){
        result = RegExp.$1;
        result = camelcaseToHyphen(result);
    }
    return result;
}
export {getComponentName};

/**
 * @method：getParentComponent
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * context：上下文，例如this
 * componentName：组件名（单个）
 * findonce：是否只返回一个实例（默认为是）
 * @description：获取父组件
 */

function getParentComponent(context, componentName, findonce){
    if (typeOf(findonce)!=='boolean'){
        findonce = true;
    }
    const ignoreVal = findonce?null:[];

    if(!context || !componentName){
        return;
    }
    var parent = context;
    var result =[];

    var componentNames = [];

    if(typeOf(componentName)==='string'){
        componentNames = [componentName];
    }else if(typeOf(componentName)==='array'){
        componentNames = componentName;
    }
    if(!componentNames.length){
        return ignoreVal;
    }
    for(var z in componentNames){
        componentNames[z] = camelcaseToHyphen(componentNames[z]);
    }
    while (parent.$parent) {
        parent=parent.$parent;
        var name = getComponentName(parent);
        if(name && componentNames.indexOf(name)>-1){
            result.push(parent);
            if(findonce) break;
        }
    }
    return findonce?result[0] || null:result;
}
export {getParentComponent};

/**
 * @method：getChildComponent
 * @createdBy:HuangJian
 * @date:2018/11/17
 * @params：
 * context：上下文
 * componentName：组件名（可以是一个数组）
 * findonce：是否只返回一个实例（默认为是）
 * @description：获取子组件
 */

function getChildComponent(context, componentName, findonce){

    if (typeOf(findonce)!=='boolean'){
        findonce = true;
    }
    const ignoreVal = findonce?null:[];
    if(!context || !componentName){
        return ignoreVal;
    }

    var componentNames = [];

    if(typeOf(componentName)==='string'){
        componentNames = [componentName];
    }else if(typeOf(componentName)==='array'){
        componentNames = componentName;
    }
    if(!componentNames.length){
        return ignoreVal;
    }
    for(var z in componentNames){
        componentNames[z] = camelcaseToHyphen(componentNames[z]);
    }
    const queryHandler = function (components) {
        var result = [];
        for(let i=0; i<components.length; i++){
            const child = components[i];
            const name = getComponentName(child);

            if(name && componentNames.indexOf(name)>-1){
                if(findonce) return [child];
                else {
                    result.push(child);
                }
            }
            if(child.$children.length){
                result = result.concat(queryHandler(child.$children));
            }
        }
        return result;
    };

    var children = context.$children;
    var results = queryHandler(children || []);
    return findonce?results[0] || null:results;
}
export {getChildComponent};

/**
 * @method：getBrotherComponent
 * @createdBy:HuangJian
 * @date:2018/11/20
 * @params：
 * context:上下文
 * componentName:组件名(可以是一个数组)
 * findonce：是否只返回一个实例（默认为是）
 * @description：获取兄弟组件
 */

function getBrotherComponent(context, componentName, findonce){
    if(typeOf(findonce)!=='boolean'){
        findonce = true;
    }
    const ignoreVal = findonce?null:[];

    if(!context || !componentName) return ignoreVal;

    var componentNames = [];

    if(typeOf(componentName)==='string'){
        componentNames = [componentName];
    }else if(typeOf(componentName)==='array'){
        componentNames = componentName;
    }
    if(!componentNames.length){
        return ignoreVal;
    }
    for(var z in componentNames){
        componentNames[z] = camelcaseToHyphen(componentNames[z]);
    }
    const parent = context.$parent || {};
    const brothers = parent._isVue?parent.$children:[];
    const result = [];

    for(var i in brothers){
        const brother = brothers[i];
        var name = getComponentName(brother);
        if(name
            && componentNames.indexOf(name)>-1
            && context._uid !== brother._uid){
            result.push(brother);
            if(findonce){
                break;
            }

        }
    }
    return findonce?result[0] || null:result;
}
export {getBrotherComponent};

/* istanbul ignore next */
const trim = function(string) {
    return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

/**
 * @method：hasClass
 * @createdBy:HuangJian
 * @date:2018/11/20
 * @params：
 * @description：判断元素是否还有某类名
 */
export function hasClass(el, cls) {
    if (!el || !cls) return false;
    if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
    if (el.classList) {
        return el.classList.contains(cls);
    } else {
        return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }
}

/**
 * @method：addClass
 * @createdBy:HuangJian
 * @date:2018/11/20
 * @params：
 * @description：给元素添加类名
 */
export function addClass(el, cls) {
    if (!el) return;
    let curClass = el.className;
    const classes = (cls || '').split(' ');

    for (let i = 0, j = classes.length; i < j; i++) {
        const clsName = classes[i];
        if (!clsName) continue;

        if (el.classList) {
            el.classList.add(clsName);
        } else {
            if (!hasClass(el, clsName)) {
                curClass += ' ' + clsName;
            }
        }
    }
    if (!el.classList) {
        el.className = curClass;
    }
}

/**
 * @method：removeClass
 * @createdBy:HuangJian
 * @date:2018/11/20
 * @params：
 * @description：移除元素类名
 */
export function removeClass(el, cls) {
    if (!el || !cls) return;
    const classes = cls.split(' ');
    let curClass = ' ' + el.className + ' ';

    for (let i = 0, j = classes.length; i < j; i++) {
        const clsName = classes[i];
        if (!clsName) continue;

        if (el.classList) {
            el.classList.remove(clsName);
        } else {
            if (hasClass(el, clsName)) {
                curClass = curClass.replace(' ' + clsName + ' ', ' ');
            }
        }
    }
    if (!el.classList) {
        el.className = trim(curClass);
    }
}
/**
 * @method：getStyle
 * @createdBy:HuangJian
 * @date:2019/1/14
 * @params：
 * el:元素
 * prop:属性 （可选）
 * removePx: 是否移除元素值里px
 * @description：获取元素的样式属性
 */
export function getStyle(el, prop, removePx=false){
    if(!el) return null;
    const elStyle = document.defaultView.getComputedStyle(el);
    var rslt = elStyle;
    if(prop && typeOf(prop)==='string'){
        rslt = elStyle[prop];
    }
    if(removePx && rslt && typeOf(rslt)==='string'){
        rslt = rslt.replace(/px/g, '');
        rslt = rslt?rslt-0:0;
    }
    return rslt;
}
/**
 * @method：
 * @createdBy:黄安邦
 * @date:2018/5/19
 * @params：
 * @description：原系统的记录明细功能,将当前的对象传递进来,将查询出该记录的用户信息\记录信息.
 */
export function showDataDetail(obj) {

    if (linkTools.isEmpty(obj)) {

    } else {
        var id = obj.id;
        var created = obj.created;
        try {
            created = created.replace(/.[0-9]+$/, '');
        }catch (e) {}
        var createdBy = obj.createdBy;
        var lastUpdated = obj.lastUpdated;
        var lastUpdatedBy = obj.lastUpdatedBy;
        var createdByName = '';
        var createdBycode = '';
        var lastUpdatedByName = '';
        var lastUpdatedcode = '';
        var tmp = '记录编号:&nbsp;[id]<br/>创建人:&nbsp;[name1]&nbsp;#[code1]<br/>创建时间:&nbsp;[cdate]<br/>最后更新人:&nbsp;[name2]&nbsp;#[code2]<br/>最后更新时间:&nbsp;[ldate]';
        tmp = tmp.replace('[id]', id).replace('[cdate]', created).
            replace('[ldate]', lastUpdated);
        var url = appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/user/queryByIds`;
        var data = {ids: [createdBy, lastUpdatedBy]};
        var self = this;
        axios1.post(url, data
        ).then(function (res) {

            if (res.data.success) {
                var result = res.data.result;
                if (result[0]) {
                    createdByName = result[0].firstName;
                    createdBycode = result[0].username;
                }
                if (result[1]) {
                    lastUpdatedByName = result[1].firstName;
                    lastUpdatedcode = result[1].username;
                }
            }
            tmp = tmp.replace('[name1]', createdByName).replace('[code1]', createdBycode).
                replace('[name2]', lastUpdatedByName).
                replace('[code2]', lastUpdatedcode);
            self.$alert(tmp, '关于记录', {dangerouslyUseHTMLString: true});

        }, function (res) {
            tmp = tmp.replace('[name1]', createdByName).replace('[code1]', createdBycode).
                replace('[name2]', lastUpdatedByName).
                replace('[code2]', lastUpdatedcode);
            self.$alert(tmp, '关于记录', {dangerouslyUseHTMLString: true});
        });

    }

};

/**
 * @method：isParentOf
 * @createdBy:HuangJian
 * @date:2019/11/27
 * @params：
 * @description：判断是否为某个组件的父组件
 */
export function $isParentOf(context){
    let value = false;
    let parent = context.$parent;
    while (parent){
        if(parent === this){
            value = true;
            break;
        }
        parent = parent.$parent;
    }
    return value;
}
/**
 * @method：isDef
 * @createdBy:HuangJian
 * @date:2019/11/27
 * @params：
 * @description：判断变量是否定义
 */
export function isDef (v) {
	return v !== undefined && v !== null
}
export function lovname(value, type) {
    if(typeof value !== 'string') return value;
    return linkLov.getLovShowName(type, value);
};

const vueMethods = {showDataDetail, lovname, $isParentOf};

export default {
    install(vue){
        for(var key in vueMethods){
            vue.prototype[key] = vueMethods[key];
        }
    }
};


